<h3 class="filter-group_heading">{{ groupName | translate }}</h3>

<app-filter-group-list
  [filterItems]="filterItems"
  (filterToggled)="onFilterToggled($event)">
</app-filter-group-list>
